export default __webpack_public_path__ + "static/media/logo2.f4e51f93.png";